import "./NotFound.css"

export function NotFound() {
	return (
		<div className="NotFound">
			<h3 className="bs-h3">Sorry, page not found!</h3>
		</div>
	)
}
